export default "__VITE_ASSET__TxOyTIjB__"